import React, { Component } from "react";
import ZoneStatusLogRow from "./ZoneStatusLogRow";

class GolfStatusTable extends Component {
  state = { golflist: "None" };
  _makeRemoteRequest = () => {
    fetch("/golfstatus")
      .then(
        response => {
          return response.json();
        },
        err => {
          console.log("error", err);
        }
      )
      .then(data => {
        this.setState({ golflist: data.golflist, timestamp: data.timestamp });
      });
  };
  componentDidMount() {
  this._makeRemoteRequest();
  }
  render() {
    if (this.state.golflist === "None")
      return "No Status known on the LFA Golf's.";

    console.log(this.state.golflist);
    console.log("We hebben net de state afgeprint");
    let new_datestring = new Date(this.state.timestamp).toLocaleString("en-GB").replace('/','-').replace('/','-');

    return (
      <div>
        <div className="alert alert-success" role="alert">
            {"Updated at "+new_datestring}
        </div>
        <table className="table table-striped table-sm">
          <thead className="thead-dark">
            <tr>
              <th>Gliding Zone</th>
              <th>Status</th>
              <th>FL</th>
              <th>Open Time(LT)</th>
              <th>Close Time(LT)</th>
            </tr>
          </thead>
          <tbody>
            {this.state.golflist.map(zone => (
              <ZoneStatusLogRow key={zone.name} zone={zone} />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default GolfStatusTable;
